import { formatPriceShort } from "@/lib/v2/format";
import { cn } from "@/lib/utils";
import { Pill } from "./Pill";

export function AvailabilityBars({
  rows,
  updatedAt,
  embedded = false,
}: {
  rows: Array<{
    label: string;
    total: number;
    available: number;
    priceFrom?: number | null;
  }>;
  updatedAt?: string;
  embedded?: boolean;
}) {
  return (
    <div
      className={cn(
        !embedded && "rounded-2xl border border-line bg-white p-5 md:p-6",
      )}
    >
      <div className="space-y-5">
        {rows.map((row) => {
          const percent = row.total > 0 ? Math.min(100, (row.available / row.total) * 100) : 0;
          return (
            <div key={row.label} className="grid gap-2 md:grid-cols-[10rem_1fr_auto] md:items-center md:gap-4">
              <p className="font-semibold text-ink">{row.label}</p>
              <div className="h-1.5 overflow-hidden rounded-full bg-line" aria-hidden="true">
                <div className="h-full rounded-full bg-avail" style={{ width: `${percent}%` }} />
              </div>
              <div className="md:min-w-32 md:text-right">
                {row.available === 0 ? (
                  <Pill tone="soldout">Sold out</Pill>
                ) : (
                  <p className="text-sm font-medium text-ink-muted">
                    {row.available} of {row.total} left
                  </p>
                )}
                {row.priceFrom != null && (
                  <p className="mt-1 text-xs text-gold-600">
                    From {formatPriceShort(row.priceFrom)}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {updatedAt && <p className="mt-5 text-xs text-ink-faint">Updated {updatedAt}</p>}
    </div>
  );
}
